module.exports = __webpack_public_path__ + "img/logo.1098cf6.png";